<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
    <title>Icons/check/ic_check_3</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Icons/check/ic_check_3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        id="ic_check_2"
        d="M12.0011429,-2.84217094e-14 C18.5908571,-2.84217094e-14 23.9542857,5.31885714 24,11.9188571 L24,11.9188571 L24,12.0011429 C23.9988571,18.5931429 18.68,23.9554286 12.0777143,24 L12.0777143,24 L11.9977143,24 C5.41142857,24 0.0525714286,18.6891429 0.00114285714,12.0948571 L0.00114285714,12.0948571 L0,12.0948571 L0,11.9988571 C0,5.40685714 5.31885714,0.0457142857 11.9177143,-2.84217094e-14 L11.9177143,-2.84217094e-14 Z M12.0011429,1.14285694 L11.9257143,1.14285694 C5.95428571,1.18171429 1.14171429,6.03542857 1.14171429,11.9988571 L1.14171429,11.9988571 L1.14285714,12.0594286 L1.14285714,12.0731429 C1.18171429,18.0434286 6.03542857,22.8582857 11.9977143,22.8571431 L11.9977143,22.8571431 L12.0731429,22.8571431 C18.0434286,22.8171429 22.8571429,17.9645714 22.8571429,12.0011429 L22.8571429,12.0011429 L22.8571429,11.9268571 C22.816,5.95542857 17.9611429,1.14171429 12.0011429,1.14285694 L12.0011429,1.14285694 Z M15.9157714,8.80685714 C16.1386286,8.584 16.5009143,8.584 16.7237714,8.80685714 C16.9466286,9.02971429 16.9466286,9.392 16.7237714,9.61485714 L16.7237714,9.61485714 L11.1443429,15.1931429 C10.9214857,15.416 10.5592,15.416 10.3363429,15.1931429 L10.3363429,15.1931429 L7.27462857,12.1314286 C7.05177143,11.9085714 7.05177143,11.5462857 7.27462857,11.3234286 C7.49862857,11.1005714 7.85977143,11.1005714 8.08262857,11.3234286 L8.08262857,11.3234286 L10.7409143,13.9805714 Z"
        fill="white"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CheckCircle",
}
</script>
